import { common } from './common';

export const ja = {
  common,
};